<template>
  <div>
    <section class="section headerBackground">
      <div class="container headerTitle">
        <h1 class="title pageHeaderTekst">Manage Sitoo Products</h1>
      </div>
    </section>
    <section class="section">
      <div class="productGrid">
        <div class="card" v-for="item in items" v-bind:key="item.id">
          <header class="card-header">
            <p class="card-header-title">
              <b-icon pack="fas" icon="image" class="imageIcon"></b-icon>
              {{ item.title }}
            </p>
          </header>
          <div class="card-content">
            <div class="content">
              <div>SKU: {{ item.sku }} </div>
              <div>Price: {{ item.moneyprice }} </div>
              <div>Price in: {{ item.moneypricein }} </div>
              <div>barcode: {{ item.barcode }} </div>
              <time>Last modified: {{ item.datemodified ? new Date(item.datemodified).toLocaleDateString() : '' }}</time>
            </div>
          </div>
          <footer class="card-footer">
            <a class="card-footer-item">Share</a>
            <a class="card-footer-item">Edit</a>
            <a class="card-footer-item">Delete</a>
          </footer>
        </div>
      </div>
    </section>
  </div>
</template>

<style scoped>
.headerBackground {
  min-height: 200px;
  background-image: url("../assets/images/headerBackgroundProducts.svg");
  background-size: cover;
}
.pageHeaderTekst {
  font-weight: 200;
  font-size: 2.2rem;
  color: #ff8484;
  text-align: center;
  margin-bottom: 30px;
}
.productGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-column-gap: 25px;
  grid-row-gap: 25px;
}
.imageIcon {
  margin-right: 10px;
  color: #888888;
}
.card-header-title { color: #9298FE; }
.card-footer-item { color: #ff8484 !important; font-size: 0.75rem; }
</style>

<script>
import products from '../mock-data/products.json'

export default {
  data() {
    return {
      items: products.items
    }
  }
}
</script>

